// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const noop = (..._: any[]): void => {};
